// extracted by mini-css-extract-plugin
module.exports =  {"relativeTimestampTooltip":"B2xPCBfa"};